import * as types from "../types";


export const uploadedAuctionInvListRequest = ({accessToken,auction_id}) => ({
    type: types.FETCH_UPLOADED_AUCTION_INVENTORY_REQUEST,
    payload:{
        accessToken, auction_id
    }
})

export const uploadedAuctionInvListSuccess = ({uploadedAuctionInvResult}) => ({
    type: types.FETCH_UPLOADED_AUCTION_INVENTORY_SUCCESS,
    payload:{
        uploadedAuctionInvResult
    }
})

export const uploadedAuctionInvListFailure = ({error}) => ({
    type: types.FETCH_UPLOADED_AUCTION_INVENTORY_FAILURE,
    payload:{
        error: error.message
    }
})